import React from "react";
import ViewExamResultFilterModalState, { ViewExamResultFilterModalProps } from "./ViewExamResultFilterModal.models";
import './ViewExamResultFilterModal.scss';
import CourseService from "../../../services/education/CourseService";
import { Modal } from "react-bootstrap";
import SelectInput from "../../shared/select/SelectInput";
import AuthContext from "../../../contexts/AuthContext";

export default class ViewExamResultFilterModal extends React.PureComponent<ViewExamResultFilterModalProps, ViewExamResultFilterModalState>{
    courseService: CourseService;
    constructor(props: any) {
        super(props);
        this.courseService = new CourseService();
        this.state = { courses: [], showModal: false };
    }
    getCourses = (studentFieldId: number) => {
        let self = this;

        this.courseService.getCourseListByFieldId(studentFieldId).then(function (response) {
            self.setState({ courses: response, showModal: true });
        });
    }

    openModal = (studentFieldId: number) => {
        this.getCourses(studentFieldId);
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    applyFilter = () => {
        this.closeModal();
        this.props.onAction(this.props.selectedPriodRange);
    }

    deleteFilter = () => {
        this.closeModal();
        this.props.onDelete();
    }

    render(): React.ReactNode {
        let { selectedCourse } = this.props;
        let { courses, showModal } = this.state;

        return (<>

            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>افزودن فیلتر</label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="col-12">
                        <SelectInput inputvalue={''} datas={courses} value={selectedCourse} name={"courses"} isNullAble={true} />
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-success" onClick={this.applyFilter}>
                        اعمال فیلتر
                    </button>
                    <button className="btn btn btn-outline-danger" onClick={this.deleteFilter}>
                        حذف فیلتر
                    </button>
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}